export const password = [
  { required: true, message: "请输入密码" },
  {
    max: 32,
    min: 6,
    message: "密码长度必须为6-32个字符",
  },
];

export const username = [
  { required: true, message: "请输入昵称" },
  {
    message: "昵称长度限制为2～10个中文或者4～20个英文字符",
    validator(_, value = "") {
      // eslint-disable-next-line no-control-regex
      const byteLenth = value.replace(/[^\x00-\xff]/g, "aa").length;
      if (byteLenth > 20 || (byteLenth < 4 && byteLenth > 0)) {
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
  },
  {
    message: "昵称不能包含@、#、$ 以及空格等特殊字符",
    validator(_, value) {
      if (/[@\s#$]/.test(value)) {
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
  },
];

export const telAndEmail = [
  { required: true, message: "请输入手机号或者邮箱" },
];

export const tel = [
  {
    message: "请输入正确的手机号",
    validator(_, tel) {
      const isChina = tel.areaCode === "+86";

      // 稿定参考 https://git.gaoding.com/gaoding/auth/blob/6042c6efaccb26a5139d6c6927c91b0bb42cb0c4/packages/auth-next/src/utils/validator.ts
      const check = isChina
        ? /^1[3-9]\d{9}$/.test(tel.number)
        : /^\d{6,}$/.test(tel.number);

      if (check) {
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    },
  },
];

export const accept = [{ required: true, message: "请勾选接受协议" }];

export const captcha = [{ required: true, message: "请输入验证码" }];

export const job = [{ required: true, message: "请选择职业" }];

/**@type {import("antd").FormItemProps["rules"]} */
export const email = [
  {
    type: "email",
    message: "请输入正确的邮箱地址",
  },
  { required: true, message: "请输入邮箱" },
];

const rules = {
  password,
  username,
  accept,
  captcha,
  tel,
  telAndEmail,
  email,
  job,
};

export default rules;
